import React, { FC, useState } from 'react';
import cs from 'classnames';
import ReactTruncate from 'react-truncate';
import { atoms, theme } from '@fiverr-private/theme';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { Container, Stack } from '@fiverr-private/layout_components';

import { breakSpaces, descriptionText, fitContent } from '../shared/styles.ve.css';
import { T_KEY } from '../utils';

interface ExperienceDescriptionProps {
    description?: string | null;
}

const ExperienceDescription: FC<ExperienceDescriptionProps> = ({ description }) => {
    const [shouldTruncateDescription, setShouldTruncateDescription] = useState(true);
    const isSm = window?.innerWidth < theme.numericBreakpoints.md;

    return (
        <Container
            className={cs(
                atoms({
                    fontSize: 'b_sm',
                }),
                breakSpaces
            )}
        >
            {shouldTruncateDescription ? (
                <Stack gap="1" direction="column" className={descriptionText}>
                    <ReactTruncate
                        lines={isSm ? 3 : 2}
                        onTruncate={(isTruncated) => setShouldTruncateDescription(isTruncated)}
                        ellipsis={<span className={descriptionText}>...</span>}
                    >
                        {description?.split('\n').map((line, i, arr) => {
                            const newLine = <span key={i}>{line}</span>;

                            if (i === arr.length - 1) {
                                return newLine;
                            } else {
                                return [newLine, <br key={`${i}br`} />];
                            }
                        })}
                    </ReactTruncate>
                    {shouldTruncateDescription && (
                        <Text
                            decoration="underline"
                            cursor="pointer"
                            whiteSpace="nowrap"
                            size="b_sm"
                            onClick={() => setShouldTruncateDescription(false)}
                            className={fitContent}
                        >
                            <I18n k={`${T_KEY}.read_more`} />
                        </Text>
                    )}
                </Stack>
            ) : (
                <Text size="b_sm" className={breakSpaces}>
                    {description}
                </Text>
            )}
        </Container>
    );
};

export default ExperienceDescription;
